module.exports = __webpack_public_path__ + "img/logo_new_agenda_blue.4a84c7cf.png";